import { IntegrationPartner, type IntegrationKey } from '@centric-os/types';
import { INTEGRATION_DEFINITIONS, INTEGRATION_KEYS } from '../../../constants/integrations';

const ThriveBoostIntegrationTypes = [
  IntegrationPartner.BOOST.toLowerCase(),
  IntegrationPartner.THRIVE.toLowerCase(),
];

/**
 * Returns true when integrationType maps to thrive/boost.
 */
export const isThriveOrBoostIntegrationType = (integrationType?: string | null): boolean => {
  const type = String(integrationType ?? '').toLowerCase();
  return ThriveBoostIntegrationTypes.includes(type);
};

export const isIntegrationKey = (value: unknown): value is IntegrationKey =>
  typeof value === 'string' && Object.hasOwn(INTEGRATION_DEFINITIONS, value);

/** Station integration key for a partner, or undefined if it isn't a station integration. */
export const getIntegrationKey = (partner?: IntegrationPartner): IntegrationKey | undefined =>
  INTEGRATION_KEYS.find((key) => INTEGRATION_DEFINITIONS[key].partner === partner);

/** Partner for a station integration key (e.g. a route param), or undefined if unknown. */
export const getIntegrationPartner = (key: unknown): IntegrationPartner | undefined =>
  isIntegrationKey(key) ? INTEGRATION_DEFINITIONS[key].partner : undefined;
